import { render, staticRenderFns } from "./AssetHRM.vue?vue&type=template&id=22a3d94a&"
import script from "./AssetHRM.vue?vue&type=script&lang=js&"
export * from "./AssetHRM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports